module.exports = __webpack_public_path__ + "static/img/plan3.b682de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/plans/plan3.png
// module id = VJux
// module chunks = 35